module.exports = __webpack_public_path__ + "img/learn.af6702a9.png";